<mat-form-field class="full-width">
  <mat-label>{{ labelText }}</mat-label>
  <textarea
    matInput
    name="tb{{ uuid }}"
    cdkTextareaAutosize
    #autosize="cdkTextareaAutosize"
    [placeholder]="placeholder"
    [cdkAutosizeMinRows]="minRows"
    [cdkAutosizeMaxRows]="maxRows"
    [required]="required"
    (change)="onChange($event)"
    [value]="value"
  ></textarea>
  <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
</mat-form-field>
